const messages = {
  pt: {
    translations: {
      settingsSidebar: {
        title: "Configurações",
        notificationsSection: "Notificações",
        enableAll: "Habilitar todas notificações",
        enableSound: "Habilitar som das notificações",
        gestorSection: "Notificações (gestor)",
        scopeAll: "Habilitar notificações de todas conversas ACEITAS",
        scopeMine: "Habilitar notificações somente das minhas conversas",
        scopeDisabled: "Desabilitar todas notificações",
        appearanceSection: "Aparência",
        darkMode: "Modo escuro",
        fontSizeMensagens: "Tamanho da fonte das mensagens",
        close: "Fechar",
      },
      signup: {
        title: "Cadastre-se",
        toasts: {
          success: "Usuário criado com sucesso! Faça seu login!!!.",
          fail: "Erro ao criar usuário. Verifique os dados informados.",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Cadastrar",
          login: "Já tem uma conta? Entre!",
        },
      },
      login: {
        title: "Faça o seu login agora",
        form: {
          email: "Insira o e-mail",
          password: "Coloque a sua senha",
        },
        buttons: {
          submit: "Fazer login",
          register: "Não tem um conta? Cadastre-se!",
        },
      },
      auth: {
        toasts: {
          success: "Login efetuado com sucesso!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Tickets today: ",
          },
        },
        messages: {
          inAttendance: {
            title: "Em serviço"
          },
          waiting: {
            title: "Esperando"
          },
          closed: {
            title: "Fechado"
          }
        }
      },
      connections: {
        title: "Conexões WhatsApp",
        toasts: {
          deleted: "Conexão com o WhatsApp excluída com sucesso!",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "Tem certeza? Você precisará ler o QR Code novamente.",
        },
        buttons: {
          add: "Adicionar WhatsApp",
          disconnect: "desconectar",
          disconnectOficialHint: "Conexões de canal Meta (WhatsApp oficial, Messenger, Instagram) não podem ser desconectadas pelo sistema",
          tryAgain: "Tentar novamente",
          qrcode: "QR CODE",
          newQr: "Novo QR CODE",
          generateQr: "Gerar QR Code",
          newDevice: "Conectar novo aparelho",
          connecting: "Conectando",
          connected: "Conectado",
        },
        toolTips: {
          disconnected: {
            title: "WhatsApp desconectado",
            content:
              "A conexão caiu por motivo inesperado. Clique em 'Tentar Novamente' para reconectar reaproveitando o pareamento atual.",
          },
          cleanSession: {
            title: "Aguardando pareamento",
            content:
              "Não há sessão ativa para esta conexão (foi desconectada manualmente, deslogada do celular ou o QR Code expirou). Clique em 'Gerar QR Code' para parear um aparelho.",
          },
          forbidden: {
            title: "Conexão recusada pelo WhatsApp",
            content:
              "O WhatsApp recusou esta conexão (geralmente conta banida ou restringida temporariamente). Verifique a situação do número no celular. Você pode tentar novamente daqui a algumas horas, ou usar 'Conectar novo aparelho' para parear com outro número.",
          },
          duplicateNumber: {
            title: "Número já conectado em outra conexão",
            content:
              "Este celular já está pareado em outra conexão deste sistema. Para evitar mensagens duplicadas, esta sessão foi desconectada automaticamente. Use 'Gerar QR Code' para parear com um número diferente, ou remova esta conexão se não for mais necessária.",
          },
          qrcode: {
            title: "Esperando leitura do QR Code",
            content:
              "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
          },
          connected: {
            title: "Conexão estabelecida!",
          },
          timeout: {
            title: "A conexão com o celular foi perdida",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code",
          },
        },
        table: {
          name: "Nome",
          canal: "Canal",
          connectedNumber: "Número conectado",
          status: "Status",
          lastUpdate: "Última atualização",
          default: "Padrão",
          actions: "Ações",
          session: "Sessão",
        },
      },
      whatsappModal: {
        title: {
          add: "Adicionar WhatsApp",
          edit: "Editar WhatsApp",
        },
        form: {
          name: "Nome",
          default: "Padrão",
          farewellMessage: "Mensagem de despedida"
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "WhatsApp salvo com sucesso.",
      },
      qrCode: {
        message: "Leia o QrCode para iniciar a sessão",
        title: "Escaneie para conectar",
        connection: "Conexão",
        step1: "Abra o WhatsApp no seu celular.",
        step2: "Toque em **Mais opções (⋮)** ou **Configurações** e depois em **Dispositivos conectados**.",
        step3: "Toque em **Conectar dispositivo**.",
        step4: "Aponte a câmera do celular para este QR code.",
        waiting: "Gerando o QR code...",
        expires: "O QR code expira em alguns segundos e é renovado automaticamente.",
      },
      contacts: {
        title: "Contatos",
        toasts: {
          deleted: "Contato excluído com sucesso!",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Deletar ",
          importTitlte: "Importar contatos",
          deleteMessage:
            "Tem certeza que deseja deletar este contato? Todos os tickets relacionados serão perdidos.",
          importMessage: "Deseja importas todos os contatos do telefone?",
        },
        buttons: {
          import: "Importar Contatos",
          add: "Adicionar Contato",
        },
        table: {
          name: "Nome",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Ações",
        },
      },
      contactModal: {
        title: {
          add: "Adicionar contato",
          edit: "Editar contato",
        },
        form: {
          mainInfo: "Dados do contato",
          extraInfo: "Informações adicionais",
          name: "Nome",
          number: "Número do Whatsapp",
          email: "Email",
          extraName: "Nome do campo",
          extraValue: "Valor",
        },
        buttons: {
          addExtraInfo: "Adicionar informação",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Contato salvo com sucesso.",
      },
      quickAnswersModal: {
        title: {
          add: "Adicionar Resposta Rápida",
          edit: "Editar Resposta Rápida",
        },
        form: {
          shortcut: "Atalho",
          message: "Resposta Rápida",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Resposta Rápida salva com sucesso.",
      },
      queueModal: {
        title: {
          add: "Adicionar fila",
          edit: "Editar fila",
        },
        form: {
          name: "Nome",
          color: "Cor",
          greetingMessage: "Mensagem de saudação",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
      },
      userModal: {
        title: {
          add: "Adicionar usuário",
          edit: "Editar usuário",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          profile: "Perfil",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Usuário salvo com sucesso.",
      },
      chat: {
        noTicketMessage: "Selecione uma conversa para começar.",
        conversaNaoEncontrada: "Conversa não encontrada.",
        conversaNaoEncontradaDetalhe: "Ela não existe ou é de uma conexão que você não acessa.",
        conversaErroCarregar: "Não foi possível carregar esta conversa.",
        conversaTentarNovamente: "Tentar novamente",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Novo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Etapas do board",
      },
      tickets: {
        toasts: {
          deleted: "O ticket que você estava foi deletado.",
        },
        notification: {
          message: "Mensagem de",
        },
        tabs: {
          open: { title: "Conversas" },
          closed: { title: "Resolvidos" },
          search: { title: "Pesquisar" },
        },
        search: {
          placeholder: "Buscar contatos",
        },
        buttons: {
          showAll: "Todos",
        },
      },
      transferTicketModal: {
        title: "Alterar Dados do Lead",
        titleGroup: "Alterar Dados do Grupo",
        fieldQueueLabel: "Transferir Etapa",
        fieldLabel: "Digite para buscar usuários",
        noOptions: "Nenhum usuário encontrado com esse nome",
        buttons: {
          ok: "Salvar",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "Aguardando",
        assignedHeader: "Conversas",
        noTicketsTitle: "Nada aqui!",
        noTicketsMessage:
          "Nenhuma conversa encontrada",
        connectionTitle: "Conexão que está sendo utilizada atualmente.",
        buttons: {
          accept: "Aceitar",
        },
      },
      newTicketModal: {
        title: "Novo lead",
        connection: "Conexão",
        name: "Nome do contato",
        number: "Número de telefone",
        invalidNumber: "Número inválido. Digite com DDD (e opcionalmente DDI 55).",
        successNew: "Atendimento iniciado!",
        infoExisting: "Já existe um atendimento para este contato nesta conexão.",
        add: "Adicionar",
        buttons: {
          ok: "Salvar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexões",
          tickets: "Tickets",
          contacts: "Contatos",
          quickAnswers: "Respostas Rápidas",
          queues: "Etapa",
          administration: "Administração",
          users: "Usuários",
          settings: "Configurações",
          ZDG: "Envio Automático",
          ZDGMedia: "Envio de Mídia",
          ZDGGroups: "Grupos",
          Direct: "Direct IG",
          SMS: "SMS",
          VoiceCall: "Chamada Telefônica",
          ZDGChatbot: "Chatbot",
          ZDGAgendamento: "Agendadas",
          ZDGHistorico: "Histórico"

        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Sair",
          },
        },
      },
      notifications: {
        noTickets: "Nenhuma notificação.",
      },
      queues: {
        title: "Etapa",
        table: {
          name: "Nome",
          color: "Cor",
          greeting: "Mensagem de saudação",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar fila",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! Os tickets dessa fila continuarão existindo, mas não terão mais nenhuma fila atribuída.",
        },
      },
      queueSelect: {
        inputLabel: "Etapa",
      },
      quickAnswers: {
        title: "Respostas Rápidas",
        table: {
          shortcut: "Atalho",
          message: "Resposta Rápida",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Resposta Rápida",
        },
        toasts: {
          deleted: "Resposta Rápida excluída com sucesso.",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle:
            "Você tem certeza que quer excluir esta Resposta Rápida: ",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
      },
      users: {
        title: "Usuários",
        table: {
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar usuário",
        },
        toasts: {
          deleted: "Usuário excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados do usuário serão perdidos. Os tickets abertos deste usuário serão movidos para a fila.",
        },
      },
      settings: {
        success: "Configurações salvas com sucesso.",
        title: "Configurações",
        settings: {
          userCreation: {
            name: "Criação de usuário",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
          timeCreateNewTicket: {
            name: "Mensagem de boas-vindas após",
            note: "Selecione o tempo que será necessário para abrir um novo ticket, caso o cliente entre em contatos novamente",
            options: {
              "10": "10 Segundos",
              "30": "30 Segundos",
              "60": "1 minuto",
              "300": "5 minutos",
              "1800": "30 minutos",
              "3600": "1 hora",
              "7200": "2 horas",
              "21600": "6 horas",
              "43200": "12 horas",
              "86400": "24 horas",
              "172800": "48 horas",
            },
          },
          call: {
            name: "Aceitar chamadas",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
          CheckMsgIsGroup: {
            name: "Ignorar Mensagens de Grupos",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
        },
      },
      messagesList: {
        encaminhada: "Encaminhada",
        apagadaPeloCliente: "Mensagem apagada pelo cliente",
        apagada: "Mensagem apagada",
        header: {
          assignedTo: "Atribuído à:",
          connection: "Conexão:",
          buttons: {
            return: "Retornar",
            resolve: "Encerrar",
            reopen: "Reabrir",
            accept: "Aceitar",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Digite uma mensagem",
        placeholderClosed: "Atendimento encerrado — clique em REABRIR no cabeçalho para responder.",
        placeholderPending: "Aceite o atendimento no cabeçalho para responder.",
        signMessage: "Assinar",
        audio: {
          permissaoNegada: "O navegador bloqueou o microfone para este site. Clique no ícone ao lado do endereço, permita o microfone e recarregue a página.",
          semMicrofone: "Nenhum microfone encontrado. Conecte um microfone ou fone e tente novamente.",
          microfoneEmUso: "O microfone está sendo usado por outro programa. Feche o outro programa e tente novamente.",
          contextoInseguro: "Gravar áudio só funciona em conexão segura (https). Acesse o sistema pelo endereço https.",
          falhaGravar: "Não foi possível iniciar a gravação",
          semGravacao: "Nada foi gravado — segure o microfone por alguns segundos antes de enviar.",
        },
        midia: {
          tituloVideoGrande: "Vídeo acima do limite",
          videoGrande: "O vídeo \"{{nome}}\" tem {{tamanho}}. O WhatsApp só envia vídeo até {{limite}}. Enviar como documento? O contato recebe o arquivo para baixar, em vez do vídeo tocando na conversa.",
          enviarComoDocumento: "Enviar como documento",
          acimaDoTeto: "O arquivo \"{{nome}}\" tem {{tamanho}} e o WhatsApp não envia nada acima de {{limite}}. Reduza o arquivo e tente de novo.",
        },
      },
      contactDrawer: {
        header: "Dados do contato",
        buttons: {
          edit: "Editar contato",
        },
        extraInfo: "Outras informações",
      },
      ticketOptionsMenu: {
        delete: "Deletar",
        transfer: "Transferir",
        confirmationModal: {
          title: "Deletar o ticket do contato",
          message:
            "Atenção! Todas as mensagens relacionadas ao ticket serão perdidas.",
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      forwardMessageModal: {
        title: "Contatos",
        buscar: "Buscar contatos",
        grupo: "Grupo",
        semContatos: "Nenhum contato encontrado nesta conexão.",
        maxContatos: "Você pode encaminhar para no máximo {{max}} contatos por vez.",
        sucesso: "Mensagem encaminhada para {{total}} contato(s).",
        parcial: "Mensagem encaminhada para {{enviados}} de {{total}} contato(s). Veja o log para as falhas.",
        nenhumEnviado: "Não foi possível encaminhar a mensagem para nenhum dos contatos selecionados.",
        buttons: {
          ok: "Encaminhar",
          okContagem: "Encaminhar ({{total}})",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Deletar",
        reply: "Responder",
        forward: "Encaminhar",
        confirmationModal: {
          title: "Apagar mensagem?",
          message: "Esta ação não pode ser revertida.",
        },
      },
      backendErrors: {
        ERR_MIDIA_MUITO_GRANDE:
          "Arquivo grande demais para o WhatsApp. Reduza o arquivo e tente de novo.",
        ERR_MIDIA_UPLOAD:
          "Falha ao enviar o anexo. Tente novamente.",
        ERR_ENCAMINHAR_SEM_DESTINATARIOS:
          "Selecione ao menos um contato para encaminhar a mensagem.",
        ERR_ENCAMINHAR_MUITOS_DESTINATARIOS:
          "Muitos contatos selecionados para um único encaminhamento.",
        ERR_ENCAMINHAR_MENSAGEM_APAGADA:
          "Esta mensagem foi apagada e não pode ser encaminhada.",
        ERR_ENCAMINHAR_TIPO_LOCAL:
          "Esta mensagem é interna do sistema e nunca foi enviada ao WhatsApp, então não pode ser encaminhada.",
        ERR_ENCAMINHAR_SEM_PAYLOAD:
          "Esta mensagem não tem os dados originais do WhatsApp (mensagem antiga ou importada) e não pode ser encaminhada.",
        ERR_ENCAMINHAR_OFICIAL_NAO_SUPORTADO:
          "Conexões da API Oficial da Meta só permitem encaminhar mensagens de texto enviadas por você.",
        ERR_ENCAMINHAR_CONTATO_FORA_DO_ESCOPO:
          "Você não tem acesso a esta conversa: só é possível encaminhar para contatos já aceitos que estejam sob a sua responsabilidade.",
        ERR_ENCAMINHAR_CONTATO_BLOQUEADO:
          "Contato bloqueado: a mensagem não foi encaminhada para ele.",
        ERR_MENU_INVALIDO:
          "Menu inválido: são de 1 a 10 opções, e com mais de uma seção todas precisam de título.",
        ERR_BUTTONS_NOT_SUPPORTED_CANAL:
          "Este canal não aceita botões. Envie as opções como texto.",
        ERR_TIPO_NAO_SUPORTADO_CANAL:
          "Este tipo de mensagem não pode ser enviado por Messenger ou Instagram.",
        ERR_CANAL_SEM_URL_PUBLICA:
          "A conexão está sem endereço público configurado: não foi possível enviar a mídia.",
        ERR_EDIT_LOCAL_MESSAGE:
          "Esta mensagem é interna do sistema e não pode ser editada no WhatsApp.",
        ERR_EDIT_NOT_SUPPORTED_OFICIAL:
          "Conexões da API Oficial da Meta não permitem editar mensagens.",
        ERR_EDIT_CAPTION_UNAVAILABLE:
          "Não foi possível editar a legenda desta mídia. Envie a mídia novamente com a legenda correta.",
        ERR_INTERNAL_NOTE_NO_TICKET:
          "Não foi possível identificar o tíquete da anotação interna.",
        ERR_INTERNAL_NOTE_INVALID_FILE:
          "Tipo de arquivo não permitido para anexo interno.",
        ERR_INTERNAL_NOTE_FILE_TOO_LARGE:
          "Arquivo muito grande. O limite é de 10MB por arquivo.",
        ERR_INTERNAL_NOTE_UPLOAD:
          "Falha ao enviar o anexo interno. Tente novamente.",
        ERR_INTERNAL_NOTE_CREATE:
          "Não foi possível salvar a anotação interna. Tente novamente.",
        ERR_INTERNAL_NOTE_ATTACHMENT_NOT_FOUND:
          "Anexo interno não encontrado.",
        ERR_NO_WAPP_SELECTED:
          "Conexão não selecionada, por favor selecione uma pela tela do lead.",
        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
        ERR_NO_DEF_WAPP_FOUND:
          "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
        ERR_WAPP_CHECK_CONTACT:
          "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
        ERR_WAPP_INVALID_CONTACT: "Este não é um número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
        ERR_INVALID_CREDENTIALS:
          "Erro de autenticação. Por favor, tente novamente.",
        ERR_SENDING_WAPP_MSG:
          "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
        ERR_WAPP_NOT_CONNECTED:
          "A conexão do WhatsApp está reconectando. Tente novamente em instantes; se persistir, verifique a página de conexões.",
        ERR_META_SEND:
          "Erro ao enviar pela API da Meta.",
        ERR_META_FORA_JANELA:
          "Não é possível responder: o cliente não envia mensagem há mais de 7 dias. A conversa só reabre quando ele escrever de novo.",
        ERR_EXTERNAL_LOGIN:
          "Erro no loin externo.",
        ERR_DELETE_WAPP_MSG: "Não foi possível excluir a mensagem do WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Já existe um lead aberto para este contato.",
        ERR_SESSION_EXPIRED: "Sessão expirada. Por favor entre.",
        ERR_USER_CREATION_DISABLED:
          "A criação do usuário foi desabilitada pelo administrador.",
        ERR_NO_PERMISSION: "Você não tem permissão para acessar este recurso.",
        ERR_BLACKLIST_FORBIDDEN:
          "Você não tem permissão para gerenciar a blacklist desta conexão.",
        ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
        ERR_NOME_OBRIGATORIO: "Informe o nome do contato.",
        ERR_NUMERO_INVALIDO: "Número inválido. Digite com DDD (e opcionalmente DDI 55).",
        ERR_ERP_NOVO_LEAD: "Falha ao criar o lead no ERP. O atendimento foi salvo como pendente.",
        ERR_NO_SETTING_FOUND: "Nenhuma configuração encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_NO_TICKET_FOUND: "Nenhum tíquete encontrado com este ID.",
        ERR_MENSAGEM_NAO_ENCONTRADA: "Não foi possível encontrar essa mensagem na conversa.",
        ERR_SEM_PERMISSAO_TICKET:
          "Você não pode responder nesta conversa. Em grupo, só quem atende na conexão do grupo; nas demais, o responsável ou um gestor da mesma filial.",
        ERR_TAG_SEM_PERMISSAO:
          "Você não tem permissão para usar ou alterar esta etiqueta.",
        ERR_TAG_NOT_FOUND:
          "Etiqueta não encontrada.",
        ERR_SEM_PERMISSAO_ASSUMIR_LEAD:
          "Você não tem permissão para assumir leads. Solicite a permissão no seu cadastro de usuário.",
        ERR_LISTAGEM_SOBRECARREGADA:
          "O sistema está com muitas consultas no momento. Aguarde alguns segundos e tente de novo.",
        ERR_AUDIO_RAPIDO_INDISPONIVEL:
          "O áudio desta resposta rápida não está mais disponível no servidor. Cadastre a resposta rápida de novo.",
        ERR_MESSAGE_NOT_FOUND: "Mensagem não encontrada.",
        ERR_REACT_LOCAL_MESSAGE: "Esta mensagem é interna do sistema, não existe no WhatsApp.",
        ERR_REACTION_INVALID_EMOJI: "Reação inválida.",
        ERR_ONLINE_FORA_HORARIO_ACESSO:
          "Você está fora do seu horário de acesso e não pode ficar online agora.",
        ERR_ONLINE_OFFLINE_ERP:
          "Não foi possível alterar seu status online. Tente novamente em instantes.",
        ERR_NO_USER_FOUND: "Nenhum usuário encontrado com este ID.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: "Erro ao criar tíquete no banco de dados.",
        ERR_FETCH_WAPP_MSG:
          "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Esta cor já está em uso, escolha outra.",
        ERR_WAPP_GREETING_REQUIRED:
          "A mensagem de saudação é obrigatório quando há mais de uma fila.",
      },
    },
  },
};

export { messages };
